<div class="additional-values-container">
  <span
    class="additional-values-badge"
    [matTooltip]="getAdditionalValuesTooltip()"
    matTooltipClass="tooltip-container"
    matTooltipPosition="below"
    [ngClass]="includePaddingInMinWidth ? 'include-padding-in-min-width' : 'do-not-include-padding-in-min-width'"
  >
    +{{ additionalValues.length }}
  </span>
</div>
